export const backgroundGray = "#BEBEBE";
export const borderGray = "#9B9B9B";
export const textGray = "#4C4C4C";
export const textBlack = "#000000";

// stat colors
export const Food = "#064700";
export const Health = "#AC0002";
export const Spirit = "#FED136";
export const Strength = "#996934";
export const Agility = "#342B9A";
export const Intellect = "#9A95FF";
export const Stamina = "#3B9D34";
